export default "__VITE_ASSET__CetSGtC7__"